import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import InlineImage from 'components/customer/summary/transactions/inline_image';
import ShippingBoxIcon from 'components/common/icons/shipping_box';

export default function ProductTile({ product }) {
  const { primaryImageUrl, name } = product;
  const placeholder = <DefaultPlaceholderImage />;

  return (
    <ProductTileContainer>
      <InlineImageContainer>
        <InlineImage imageUrl={primaryImageUrl} placeholder={placeholder} />
      </InlineImageContainer>
      <ImageCaption>{name}</ImageCaption>
    </ProductTileContainer>
  );
}

const DefaultPlaceholderImage = styled(ShippingBoxIcon)`
  height: 40%;
  width: 40%;
`;

const ProductTileContainer = styled.div`
  background-color: ${p => p.theme.colors.white};
  width: 120px;
`;

const InlineImageContainer = styled.div`
  aspect-ratio: 1;
  border: 1px solid ${p => p.theme.colors.gray400};
  box-shadow: ${p => p.theme.boxShadow.xsmall};
  border-radius: ${p => p.theme.borderRadius.default};
  overflow: hidden;
  width: 100%;
`;

/**
 * Despite being marked as "deprecated" for some time, `-webkit-line-clamp` is the only working
 * implementation and is fully supported in all browsers.
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/line-clamp
 */
const ImageCaption = styled.div`
  display: -webkit-box;
  font-size: ${p => p.theme.fontSize.base};
  font-weight: ${p => p.theme.fontWeight.mediumHeavy};
  line-clamp: 2;
  line-height: 1.25;
  min-height: 1em;
  overflow: hidden;
  margin: ${p => p.theme.spacing.medium} ${p => p.theme.spacing.xsmall};
  max-width: calc(100% - calc(2 * ${p => p.theme.spacing.xsmall}));
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

ProductTile.propTypes = {
  product: PropTypes.shape({
    primaryImageUrl: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
